import { FC, Fragment } from 'react';

import { Link } from 'react-router-dom';

import { translate } from 'utils';

export interface Breadcrumb {
  label: string;
  key?: string;
  pathname?: string;
  onClick?: () => void;
}

interface Props {
  links: Breadcrumb[];
}

export const Breadcrumbs: FC<Props> = ({ links }) => {
  return (
    <div className='flex items-center space-x-2 text-sm w-full'>
      {links?.map((link, index) => (
        <Fragment key={link?.key ?? link?.pathname ?? `breadcrumb-${index}`}>
          {link?.pathname ? (
            <Link className='truncate shrink-0' to={link?.pathname}>
              {translate(link?.label)}
            </Link>
          ) : link?.onClick ? (
            <button
              type='button'
              onClick={link.onClick}
              className='truncate shrink-0'
            >
              {translate(link?.label)}
            </button>
          ) : (
            <div className='truncate'>{translate(link?.label)}</div>
          )}
          <div>{index + 1 !== links?.length ? '/' : ''}</div>
        </Fragment>
      ))}
    </div>
  );
};
